// Perfiles de equipo (nombres ficticios y fotos de stock — reemplazar por reales).
export const director = {
  id: "enric-crespi",
  name: "Enric Crespi",
  role: "Director General · CEO",
  area: "Dirección",
  icon: "ShieldCheck",
  photo: "/team/enric-crespi.jpg",
  summary:
    "Fundador de CYVR Labs. Lidera la estrategia de seguridad ofensiva y defensiva del equipo.",
  cv: [
    "+15 años en ciberseguridad ofensiva y defensiva.",
    "Fundador y director de CYVR Labs.",
    "Certificaciones OSCP y CISSP.",
    "Especialista en Red Team, ciberinteligencia y dirección de proyectos.",
  ],
  refs: [
    "Dirección de auditorías Red Team para empresas del sector industrial y financiero.",
    "Coordinación de operaciones de ciberinteligencia y OSINT.",
    "Diseño del programa de formación en hacking ético de CYVR Labs.",
  ],
};

export const team = [
  {
    id: "alvaro-ferrandez",
    name: "Álvaro Ferrández Gil",
    role: "Ingeniero Técnico",
    area: "Hardware & Infraestructura",
    icon: "Cpu",
    photo:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&w=600&h=700&fit=crop&q=80",
    summary:
      "Despliegue de infraestructura segura y hardening de estaciones y laboratorios.",
    cv: [
      "Ingeniería Técnica Industrial — Universitat Politècnica de València.",
      "+8 años en infraestructura TI y hardening físico.",
      "Certificaciones CompTIA Security+ y CEH.",
    ],
    refs: [
      "Auditoría de infraestructura para PYME industrial.",
      "Montaje de laboratorio de análisis forense.",
      "Hardening de estaciones de trabajo corporativas.",
    ],
  },
  {
    id: "david-molto",
    name: "David Moltó Ribes",
    role: "Ingeniero de Sistemas",
    area: "SysAdmin & SOC",
    icon: "Server",
    photo:
      "https://images.unsplash.com/photo-1705645930353-0e335311ef20?crop=entropy&cs=srgb&fm=jpg&w=600&h=700&fit=crop&q=80",
    summary:
      "Administración de sistemas Linux/Windows y operación del SOC 24/7.",
    cv: [
      "Ingeniería Informática — Universitat de València.",
      "Especialista en Linux/Windows Server y plataformas SIEM.",
      "Certificaciones RHCE y Microsoft Certified.",
    ],
    refs: [
      "Implantación de un SOC 24/7 con monitorización SIEM.",
      "Migración segura de infraestructura a la nube.",
      "Respuesta a incidentes de ransomware.",
    ],
  },
  {
    id: "sergio-beltran",
    name: "Sergio Beltrán Navarro",
    role: "Ingeniero de Redes",
    area: "Network Security",
    icon: "Network",
    photo:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&w=600&h=700&fit=crop&q=80",
    summary:
      "Diseño de redes seguras, segmentación y protección perimetral.",
    cv: [
      "Grado en Ingeniería de Telecomunicaciones — UPV.",
      "Certificación CCNP Security.",
      "Experto en firewalls, VPN y segmentación de red.",
    ],
    refs: [
      "Rediseño de red segmentada para entorno multi-sede.",
      "Despliegue de firewalls perimetrales de nueva generación.",
      "Auditoría de seguridad wifi corporativa.",
    ],
  },
  {
    id: "lucia-montesinos",
    name: "Lucía Montesinos Aparicio",
    role: "Ingeniera de Programación",
    area: "Desarrollo Seguro",
    icon: "Code2",
    photo:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&w=600&h=700&fit=crop&q=80",
    summary:
      "Desarrollo seguro, pentesting de aplicaciones web y APIs.",
    cv: [
      "Grado en Ingeniería Informática + Máster en Ciberseguridad.",
      "Especialista en desarrollo seguro y metodología OWASP.",
      "Pentesting de aplicaciones web y APIs.",
    ],
    refs: [
      "Pentest de aplicaciones web y APIs para clientes SaaS.",
      "Desarrollo de herramientas internas de escaneo de CYVR Labs.",
      "Revisión de código seguro (secure code review).",
    ],
  },
  {
    id: "cristina-server",
    name: "Cristina Server Bataller",
    role: "Administración",
    area: "Finanzas & Operaciones",
    icon: "Briefcase",
    photo:
      "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&w=600&h=700&fit=crop&q=80",
    summary:
      "Gestión administrativa, facturación, contratos y cumplimiento interno.",
    cv: [
      "Grado en Administración y Dirección de Empresas (ADE).",
      "Gestión administrativa, facturación y contratos.",
      "Coordinación del cumplimiento RGPD interno.",
    ],
    refs: [
      "Gestión administrativa y económica de proyectos.",
      "Control de contratos y proveedores.",
      "Coordinación de la documentación de cumplimiento.",
    ],
  },
  {
    id: "paula-sanchis",
    name: "Paula Sanchis Ferrer",
    role: "Secretaría",
    area: "Atención al Cliente",
    icon: "Headphones",
    photo:
      "https://images.unsplash.com/photo-1699899657680-421c2c2d5064?crop=entropy&cs=srgb&fm=jpg&w=600&h=700&fit=crop&q=80",
    summary:
      "Atención al cliente, coordinación de agenda y comunicaciones.",
    cv: [
      "Técnico Superior en Administración y Gestión.",
      "Atención al cliente y coordinación de agenda.",
      "Gestión de comunicaciones y soporte al equipo.",
    ],
    refs: [
      "Coordinación de citas y soporte a clientes.",
      "Gestión de comunicaciones entrantes.",
      "Apoyo a la oficina técnica.",
    ],
  },
];
